import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    cursor: 'pointer'
  },
  containerActive: {
    extend: 'container',
    '&:hover $boxGraphic': {
      background: '#f8f9fb'
    }
  },
  boxGraphic: {
    width: '100%',
    border: '1px solid #ededed',
    padding: '20px 14px',
    background: 'white',
    borderRadius: 10,
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
    gridGap: '12px',
    alignItems: 'center',
    boxSizing: 'border-box',
    transition: 'background-color 0.15s, border-color 0.15s'
  },
  boxSelected: {
    extend: 'boxGraphic',
    boxShadow: '0px 4px 12px rgba(11, 87, 255, 0.15)',
    border: '2px solid #0b57ff',
    padding: '19px 13px', // compensate for the thicker border
    boxSizing: 'border-box'
  },
  boxText: {
    fontSize: 13,
    fontWeight: 700
  },
  title: {
    fontSize: 13.5,
    fontWeight: 600,
    color: theme.colors.primaryBlack,
    textAlign: 'center'
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 400,
    color: '#74777f',
    textAlign: 'center',
    marginTop: 3,
    lineHeight: 1.35
  }
}));

type Props = {
  selected?: boolean;
  icon: IconProp;
  boxText: string;
  title: string;
  subtitle: string;
  onClick: () => void;
  disabled?: boolean;
};

function SelectionBox(props: Props) {
  const classes = useStyles();

  const iconColor = props.selected ? '#0b57ff' : '#74777f';
  return (
    <div
      className={props.disabled ? classes.container : classes.containerActive}
      style={{ opacity: props.disabled ? 0.5 : 1 }}
      onClick={!props.disabled ? props.onClick : () => {}}
    >
      <div
        className={props.selected ? classes.boxSelected : classes.boxGraphic}
      >
        <FontAwesomeIcon
          icon={props.icon}
          color={iconColor}
          style={
            {
              '--fa-primary-color': iconColor,
              '--fa-secondary-color': iconColor,
              fontSize: '1.3rem'
            } as any
          }
        />
        <div className={classes.boxText} style={{ color: iconColor }}>
          {props.boxText}
        </div>
      </div>
      <div className={classes.title}>{props.title}</div>
      <div className={classes.subtitle}>{props.subtitle}</div>
    </div>
  );
}

export default SelectionBox;
